import React, {Component} from 'react';
import {render} from 'react-dom';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";

export default class DateTimeCustom extends React.Component {
    constructor(props) {
        super(props);
        this.spanClass = props.spanClass || "";
        this.renderInput = this.renderInput.bind(this);
        this.toggleCalendar = this.toggleCalendar.bind(this);
    }
    
    render(){
        return <Datetime style={{paddingTop:0}} {...this.props} renderInput={ this.renderInput } />;
    }

    renderInput( props, openCalendar, closeCalendar ){
        return (
            <div>
                <input {...props} />
                <span style={{cursor:"pointer"}} className={"glyphicon " + this.spanClass} onClick={(e) => this.toggleCalendar(e,openCalendar,closeCalendar)}></span>
            </div>
        );
    }

     toggleCalendar(event,openCalendar,closeCalendar) {
        function hasClass(element, className) {
            return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
        }
        event.preventDefault();
        if (event.currentTarget && event.currentTarget.previousElementSibling && !event.currentTarget.previousElementSibling.disabled) {
            (event.currentTarget.parentElement && event.currentTarget.parentElement.parentElement
            && event.currentTarget.parentElement.parentElement.parentElement
            && hasClass(event.currentTarget.parentElement.parentElement.parentElement, 'rdtOpen')) ? closeCalendar() : openCalendar();
        }
    }
}
